/**
 * Portal Manta · CONTEXTO_LOTES
 * Extraído de App.jsx v29.3 (via AST)
 */
import { DADOS } from './lotes-pr.js';
import { F } from '../tokens/fonts.js';

const CONTEXTO_LOTES = {
  '3': {
    // ─── Família 1: Extensão & Tipologia ───────────────────────
    km_urb_override:null, // null = calcula de DADOS[3].dados_manta.obras_per.travessias_urbanas
    f_km_urb:{doc:'Edital ANTT Lote 3 — PER', pag:'Anexo 2 · Travessias Urbanas', data:'2023-04-30', aut:'ANTT'},
    // OAE em m² (MEF traz por OAE individual; aqui o total)
    oae_m2_total:98_180,
    f_oae_m2:{doc:'MEF Lote 3', pag:'Aba "Orçamento Paramétrico" · linhas A9.1–A9.184', data:'2023-04-30', aut:'ANTT'},
    // Passarelas em m²
    passarela_m2_total:6_600,
    f_pass_m2:{doc:'MEF Lote 3', pag:'Aba "Orçamento Paramétrico" · A10', data:'2023-04-30', aut:'ANTT'},
    // Edificações em m² por classe
    edif_m2:{pedagio:9_800, bso_sau:4_200, base_conserv:1_500, cco_sede:1_200, ppr_rfb:1_800, total:18_500},
    f_edif_m2:{doc:'MEF Lote 3', pag:'Aba "Edificações"', data:'2023-04-30', aut:'ANTT'},
    // ─── Família 2: Condicionantes Físicas ─────────────────────
    solo:{LRA:42, saprolitico:28, coluvio:18, aluvionar:8, residual:4}, // % por extensão (SUCS simplificado)
    f_solo:{doc:'EVTEA + sondagens DNIT', pag:'Mapa pedológico EMBRAPA + SPT por OAE', data:'2022-08-15', aut:'Manta · Geotecnia'},
    pluv_mm_ano:1850, // média ponderada por extensão
    pluv_mensal:[180,165,155,110,85,70,75,90,120,150,175,205], // jan..dez
    f_pluv:{doc:'INMET — séries históricas 1991–2020', pag:'Estações: Curitiba, Maringá, Ponta Grossa', data:'2024-12-31', aut:'Manta · Drenagem'},
    topo:{plano:25, ondulado:50, montanhoso:25}, // % por extensão (Serra do Mar pesa)
    f_topo:{doc:'SRTM 30m + perfil PER', pag:'Análise altimétrica trecho-a-trecho', data:'2023-04-30', aut:'Manta · Geometria'},
    nspt_medio_oae:18, // golpes/30cm — médio nas OAEs
    f_nspt:{doc:'Sondagens SPT — projeto básico', pag:'Boletins por OAE', data:'2023-04-30', aut:'ANTT'},
  },
  '4': {
    km_urb_override:78.5, // estimativa — Lote 4 não traz travessias_urbanas
    f_km_urb:{doc:'Edital ANTT Lote 4 — PER', pag:'Anexo 2 · Travessias Urbanas (estimativa Manta)', data:'2024-01-31', aut:'Manta · GIS'},
    oae_m2_total:48_600,
    f_oae_m2:{doc:'MEF Lote 4', pag:'Aba "Orçamento Paramétrico" · A9', data:'2024-01-31', aut:'ANTT'},
    passarela_m2_total:11_700,
    f_pass_m2:{doc:'MEF Lote 4', pag:'A10', data:'2024-01-31', aut:'ANTT'},
    edif_m2:{pedagio:6_500, bso_sau:5_000, base_conserv:1_800, cco_sede:1_400, ppr_rfb:1_500, total:16_200},
    f_edif_m2:{doc:'MEF Lote 4', pag:'Aba "Edificações"', data:'2024-01-31', aut:'ANTT'},
    solo:{LRA:62, LVA:22, saprolitico:8, aluvionar:6, residual:2},
    f_solo:{doc:'EVTEA + EMBRAPA', pag:'Mapa pedológico — Norte Central PR', data:'2023-09-20', aut:'Manta · Geotecnia'},
    pluv_mm_ano:1620,
    pluv_mensal:[220,180,140,90,70,60,55,65,110,160,180,210],
    f_pluv:{doc:'INMET 1991–2020', pag:'Estações: Londrina, Maringá, Cianorte', data:'2024-12-31', aut:'Manta · Drenagem'},
    topo:{plano:55, ondulado:40, montanhoso:5},
    f_topo:{doc:'SRTM 30m', pag:'Perfil longitudinal PER', data:'2024-01-31', aut:'Manta · Geometria'},
    nspt_medio_oae:24,
    f_nspt:{doc:'Sondagens SPT', pag:'Boletins por OAE', data:'2024-01-31', aut:'ANTT'},
  },
  '5': {
    km_urb_override:42.3,
    f_km_urb:{doc:'Edital ANTT Lote 5 — PER', pag:'Anexo 2 (estimativa Manta)', data:'2024-01-31', aut:'Manta · GIS'},
    oae_m2_total:7_460,
    f_oae_m2:{doc:'MEF Lote 5', pag:'Aba "Orçamento Paramétrico" · A9', data:'2024-01-31', aut:'ANTT'},
    passarela_m2_total:1_500,
    f_pass_m2:{doc:'MEF Lote 5', pag:'A10', data:'2024-01-31', aut:'ANTT'},
    edif_m2:{pedagio:5_200, bso_sau:3_400, base_conserv:0, cco_sede:1_100, ppr_rfb:1_300, total:11_000},
    f_edif_m2:{doc:'MEF Lote 5', pag:'Aba "Edificações"', data:'2024-01-31', aut:'ANTT'},
    solo:{LRA:58, LVA:30, saprolitico:6, aluvionar:5, residual:1},
    f_solo:{doc:'EVTEA + EMBRAPA', pag:'Mapa pedológico — Oeste PR', data:'2023-09-20', aut:'Manta · Geotecnia'},
    pluv_mm_ano:1720,
    pluv_mensal:[195,170,150,110,90,75,60,80,140,180,180,195],
    f_pluv:{doc:'INMET 1991–2020', pag:'Estações: Cascavel, Toledo, Guaíra', data:'2024-12-31', aut:'Manta · Drenagem'},
    topo:{plano:60, ondulado:35, montanhoso:5},
    f_topo:{doc:'SRTM 30m', pag:'Perfil longitudinal PER', data:'2024-01-31', aut:'Manta · Geometria'},
    nspt_medio_oae:28,
    f_nspt:{doc:'Sondagens SPT', pag:'Boletins por OAE', data:'2024-01-31', aut:'ANTT'},
  }
};

export { CONTEXTO_LOTES };
export default CONTEXTO_LOTES;
